/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = formatPrice(price);
    if (comparing) {
      res +=
        ' <s class="ais-hit--price-striked">' +
        formatPrice(compare_at_price) +
        '</s> ';
      res +=
        ' <b class="ais-hit--price-discount" ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</b>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    getProductBadgesHTML: function getProductBadgesHTML() {
      var sale_badge = '';
      var sold_badge = '';
      var badge = '';
      var badge_2 = '';
      var badge_3 = '';

      //if product is soldout
      if (this.inventory_available == false) {
        sold_badge = '<div class="product-badge product-badge--soldout">[[ translations.soldOut ]]</div>';
      }
      if (this.compare_at_price > 1) {
        sale_badge = '<div class="product-badge product-badge--sale">[[ translations.onSale ]]</div>';
      }
      this.tags.forEach(function(tag) {
        if (sold_badge == '' && tag == 'label:sold-out') {
          sold_badge = '<div class="product-badge product-badge--soldout">[[ translations.soldOut ]]</div>';
        }
        if (sale_badge == '' && tag == 'label:sale') {
          sale_badge = '<div class="product-badge product-badge--sale">[[ translations.onSale ]]</div>';
        }
        if (badge == '' && tag == 'label:bio') {
          badge = '<div class="product-badge product-badge--bio">[[ translations.bio ]]</div>';
        }
        if (badge == ''  && tag == 'label:gluten-free') {
          badge = '<div class="product-badge product-badge--gluten-free">[[ translations.gluten_free ]]</div>';
        }
        if (sale_badge == '' && badge != '' && tag == 'label:gluten-free') {
          badge_2 = '<div class="product-badge product-badge--bio">[[ translations.bio ]]</div><div class="product-badge product-badge--gluten-free">[[ translations.gluten_free ]]</div>';
        }
        if (sale_badge != '' && badge_3 == '' && tag == 'label:bio') {
          badge_3 = '<div class="product-badge product-badge--sale">[[ translations.onSale ]]</div><div class="product-badge product-badge--bio">[[ translations.bio ]]</div>';
        }
        if (sale_badge != '' && badge_3 == '' && tag == 'label:gluten-free') {
          badge_3 = '<div class="product-badge product-badge--sale">[[ translations.onSale ]]</div><div class="product-badge product-badge--gluten-free">[[ translations.gluten_free ]]</div>';
        }

      });

      if (sold_badge != '') {
        return sold_badge;
      } else if (badge_3 != '') {
        return badge_3;
      } else if (badge_2 != '') {
        return badge_2;
      }else if (sale_badge != '') {
        return sale_badge;
      } else {
        return badge;
      }

    },
    getProductUspsHTML: function getProductUspsHTML() {
      var usps = '';
      var usps_items  = '';

      if (this.meta.product && this.meta.product.usps) {
        usps = algolia.helpers.fullEscapedAttribute(
          this.meta.product.usps
        );
      } else {
        return '';
      }

      if (typeof usps != 'undefined' && typeof usps != '') {
        var array = usps.split('||');
        usps_items = '<li class="product-selling-points__item"><i class="icon icon--checkmark icon--sm" aria-hidden="true"><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M8,15 C9.26762821,15 10.4455128,14.6802885 11.5336538,14.0408654 C12.588141,13.4238782 13.4238782,12.588141 14.0408654,11.5336538 C14.6802885,10.4455128 15,9.26762821 15,8 C15,7.16987179 14.8766026,6.43509615 14.6298077,5.79567308 L13.7548077,6.65384615 C13.8669872,7.1025641 13.9230769,7.55128205 13.9230769,8 C13.9230769,9.07692308 13.6538462,10.0753205 13.1153846,10.9951923 C12.599359,11.8926282 11.8926282,12.599359 10.9951923,13.1153846 C10.0753205,13.6538462 9.07692308,13.9230769 8,13.9230769 C6.92307692,13.9230769 5.92467949,13.6538462 5.00480769,13.1153846 C4.10737179,12.599359 3.40064103,11.8926282 2.88461538,10.9951923 C2.34615385,10.0753205 2.07692308,9.07692308 2.07692308,8 C2.07692308,6.92307692 2.34615385,5.92467949 2.88461538,5.00480769 C3.40064103,4.10737179 4.10737179,3.40064103 5.00480769,2.88461538 C5.92467949,2.34615385 6.92307692,2.07692308 8,2.07692308 C8.79647436,2.07692308 9.5536859,2.22836538 10.2716346,2.53125 C10.9559295,2.81169872 11.5616987,3.21554487 12.0889423,3.74278846 L12.8461538,2.98557692 C12.2179487,2.35737179 11.4859776,1.86939103 10.6502404,1.52163462 C9.81450321,1.17387821 8.93108974,1 8,1 C6.73237179,1 5.55448718,1.31971154 4.46634615,1.95913462 C3.41185897,2.57612179 2.57612179,3.41185897 1.95913462,4.46634615 C1.31971154,5.55448718 1,6.73237179 1,8 C1,9.26762821 1.31971154,10.4455128 1.95913462,11.5336538 C2.57612179,12.588141 3.41185897,13.4238782 4.46634615,14.0408654 C5.55448718,14.6802885 6.73237179,15 8,15 Z" id="Path" fill="#85AB6F" fill-rule="nonzero"></path><polygon fill="#85AB6F" fill-rule="nonzero" points="8 10.9110577 8.38701923 10.5408654 14.8485577 4.07932692 14.0745192 3.30528846 8 9.37980769 5.69471154 7.07451923 4.92067308 7.84855769 7.61298077 10.5408654"></polygon></g></svg></i>' + array[0] + '</li><li class="product-selling-points__item"><i class="icon icon--checkmark icon--sm" aria-hidden="true"><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M8,15 C9.26762821,15 10.4455128,14.6802885 11.5336538,14.0408654 C12.588141,13.4238782 13.4238782,12.588141 14.0408654,11.5336538 C14.6802885,10.4455128 15,9.26762821 15,8 C15,7.16987179 14.8766026,6.43509615 14.6298077,5.79567308 L13.7548077,6.65384615 C13.8669872,7.1025641 13.9230769,7.55128205 13.9230769,8 C13.9230769,9.07692308 13.6538462,10.0753205 13.1153846,10.9951923 C12.599359,11.8926282 11.8926282,12.599359 10.9951923,13.1153846 C10.0753205,13.6538462 9.07692308,13.9230769 8,13.9230769 C6.92307692,13.9230769 5.92467949,13.6538462 5.00480769,13.1153846 C4.10737179,12.599359 3.40064103,11.8926282 2.88461538,10.9951923 C2.34615385,10.0753205 2.07692308,9.07692308 2.07692308,8 C2.07692308,6.92307692 2.34615385,5.92467949 2.88461538,5.00480769 C3.40064103,4.10737179 4.10737179,3.40064103 5.00480769,2.88461538 C5.92467949,2.34615385 6.92307692,2.07692308 8,2.07692308 C8.79647436,2.07692308 9.5536859,2.22836538 10.2716346,2.53125 C10.9559295,2.81169872 11.5616987,3.21554487 12.0889423,3.74278846 L12.8461538,2.98557692 C12.2179487,2.35737179 11.4859776,1.86939103 10.6502404,1.52163462 C9.81450321,1.17387821 8.93108974,1 8,1 C6.73237179,1 5.55448718,1.31971154 4.46634615,1.95913462 C3.41185897,2.57612179 2.57612179,3.41185897 1.95913462,4.46634615 C1.31971154,5.55448718 1,6.73237179 1,8 C1,9.26762821 1.31971154,10.4455128 1.95913462,11.5336538 C2.57612179,12.588141 3.41185897,13.4238782 4.46634615,14.0408654 C5.55448718,14.6802885 6.73237179,15 8,15 Z" id="Path" fill="#85AB6F" fill-rule="nonzero"></path><polygon fill="#85AB6F" fill-rule="nonzero" points="8 10.9110577 8.38701923 10.5408654 14.8485577 4.07932692 14.0745192 3.30528846 8 9.37980769 5.69471154 7.07451923 4.92067308 7.84855769 7.61298077 10.5408654"></polygon></g></svg></i>' + array[1] + '</li>';
      }
      return usps_items;
    },

    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
